import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwTubeStatusSchema: SourcedocumentDataSchemaFor<"GMW_TubeStatus"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "monitoringTubes"],
  properties: {
    ...pickGmwLibraryFields(["eventDate"]),
    monitoringTubes: {
      type: "array",
      title: "Monitoringsbuis",
      items: {
        type: "object",
        required: ["tubeNumber", "tubeStatus"],
        properties: pickGmwLibraryFields(["tubeNumber", "tubeStatus"]),
      },
    },
  },
};
